export default "3ed6d90d068453e6.svg"